import React, { useMemo } from 'react';
import KanbanColumn from './KanbanColumn';
import OperationCard from '../OperationCard';

/**
 * Columna "Finalizadas" — agrupa solicitudes en estado `Aprobada`.
 *
 * Archivo independiente para que se pueda modificar sin tocar
 * las otras 3 columnas (Cotizaciones, EnCurso, Rechazadas).
 */
const FinalizadasColumn = ({ items = [], onAction, loading = false, headerExtra, actionsMode = 'full' }) => {
  const renderItem = useMemo(
    () => (r) => <OperationCard r={r} variant="finalizadas" onAction={onAction} actionsMode={actionsMode} />,
    [onAction, actionsMode],
  );

  return (
    <KanbanColumn
      id="finalizadas"
      title="Finalizadas"
      accent="border-t-emerald-500"
      badge="bg-emerald-100 text-emerald-800 border-emerald-200"
      items={items}
      renderItem={renderItem}
      loading={loading}
      emptyText="Sin solicitudes finalizadas"
      headerExtra={headerExtra}
    />
  );
};

export default FinalizadasColumn;
